<template lang="html">
  <b-row class="topbar">
    <b-col sm="12" lg="6" class="mb-sm-3 mb-3 mb-lg-0 mb-xl-0">
      <div class="top-left">
        <span>
          <b-btn
            size="md"
            variant="success"
            class="mr-3 home-button"
            @click="goHome"
          >
            <v-icon name="home" />
          </b-btn>
        </span>
        <span v-if="!displayTitleEditor" class="h2">{{ title }}</span>

        <b-form-input
          v-if="displayTitleEditor"
          v-model="editableTitle"
          type="text"
          required
          placeholder="Enter title"
          class="title-input"
          size="lg"
        />

        <b-link
          v-if="!displayTitleEditor"
          class="ml-2"
          @click="displayTitleEditor = !displayTitleEditor"
        >
          Edit
        </b-link>
        <b-btn
          v-if="displayTitleEditor"
          class="ml-1"
          size="sm"
          variant="primary"
          @click="saveNewTitle"
        >
          Save
        </b-btn>
        <b-btn
          v-if="displayTitleEditor"
          class="ml-1"
          variant="outline-secondary"
          size="sm"
          @click="
            displayTitleEditor = !displayTitleEditor;
            editableTitle = title;
          "
        >
          Cancel
        </b-btn>
      </div>
    </b-col>
    <b-col sm="12" lg="6">
      <!-- Private options are all here. -->
      <div
        v-if="privateShow && !$store.getters['show/displayInitialImporter']"
        class="float-left public-private ml-4"
      >
        <span>
          This show is private
          <b-link class="small ml-1" @click="gotoPrivacy">Edit</b-link>
        </span>
      </div>
      <div
        v-if="!privateShow && !$store.getters['show/displayInitialImporter']"
        class="float-left public-private ml-4"
      >
        <span>
          This show is public
          <b-link class="small ml-1" @click="gotoPrivacy">Edit</b-link>
        </span>
      </div>
      <div class="float-right">
        <ShareButton
          :show="$store.state.show.currentShow"
          :variant="nonActiveVariant"
        />
        <LinkButton
          :show="$store.state.show.currentShow"
          :variant="nonActiveVariant"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import ShareButton from "@/components/show/ShareButton";
import LinkButton from "@/components/show/LinkButton";
export default {
  name: "TopModeBar",
  components: {
    ShareButton,
    LinkButton
  },
  data() {
    return {
      activeVariant: "primary",
      nonActiveVariant: "outline-secondary",
      size: "md",
      editableTitle: "",
      displayTitleEditor: false
    };
  },
  computed: {
    mode() {
      return this.$route.params.mode || "timeline";
    },
    privateShow() {
      return this.$store.getters["show/isShowPrivate"];
    },
    title() {
      return this.$store.state.show.currentShow.title;
    }
  },
  watch: {
    title(value) {
      this.editableTitle = value;
    }
  },
  mounted() {
    this.editableTitle = this.title;
  },
  methods: {
    saveNewTitle() {
      this.$store.dispatch("show/updateTitle", this.editableTitle);
      this.displayTitleEditor = false;
    },
    gotoPrivacy() {
      var key = this.$store.state.show.currentShowKey;
      this.$router
        .push({
          name: "show-mode-highlight",
          params: { id: key, mode: "settings", highlight: "privacy" }
        })
        .catch(() => {});
    },
    goHome() {
      this.$router.push({ name: "shows" }).catch(() => {});
    },
    returnVariant(mode) {
      if (this.mode == mode) {
        return this.activeVariant;
      } else {
        return this.nonActiveVariant;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.public-private {
  margin-top: 12px;
}
.home-button {
  margin-top: -17px;
}
.top-left {
  margin-top: 0px;
  height: 50px;
  //background-color: pink;
}
.topbar {
  //background-color: rgba(100, 50, 0, 0.1);
  //padding: 5px;
  //padding-top: 15px;
  //border-radius: 6px;
}
.title-input {
  width: 350px;
  display: inline;
  //margin-top: -2px;
}
</style>
